$(document).ready(function() {
	if(!document.querySelector('.GPC0109')) return false;
});
